import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-termsandcondition',
  templateUrl: './termsandcondition.component.html',
  styleUrls: ['./termsandcondition.component.scss']
})
export class TermsandconditionComponent implements OnInit {

  constructor(private titleService: Title,
    private metaService: Meta) { }

  ngOnInit(): void {
    this.setSEOData();
  }

  setSEOData(): void {
   

    let aboutDescription = `Terms & Conditions of EWNS, Custom Ecommerce platform to meet all your digital needs, Enable social commerce and Ecommerce in matter of minutes, Create and manage website from anywhere on any device, Enable digital commerce for your business`;

    this.titleService.setTitle(aboutDescription);

    this.metaService.addTag({name: 'name', content: aboutDescription});
    this.metaService.addTag({name: 'description', content: aboutDescription});
    this.metaService.addTag({name: 'image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'logo', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'keywords', content: aboutDescription})


    this.metaService.addTag({name: 'twitter:card', content: 'product'});
    this.metaService.addTag({name: 'twitter:title', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:description', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})


    //OG GRAPH DATA
    this.metaService.addTag({name: 'og:type', content: 'article'});
    this.metaService.addTag({name: 'og:site_name', content: 'EWNS'});
    this.metaService.addTag({name: 'og:url', content: "https://ewns.in"});
    this.metaService.addTag({name: 'og:description', content: aboutDescription});
    this.metaService.addTag({name: 'og:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
  }

}
